
import { Prop, Vue, Component, Emit, Watch } from 'vue-property-decorator'
import { EnumPreferentialType, IS_COMPOSE_COUPON } from '@xt/client/enums'
import { BaseCouponItem } from '@xt/client/types/coupon'
import { formatCouponInfo, FormatCouponInfo, EnumCouponTimeRule } from '@xt/client/utils/coupon'

@Component
export default class ExchangeConfirmPopup extends Vue {
  @Prop({ default: false }) visible: boolean
  @Prop({ default: '确认兑换信息' }) title: string
  @Prop({ default: '确认兑换' }) btnText: string
  @Prop({ default: 'exchange' }) confirmType: 'exchange' | 'receive'
  @Prop({ default: () => {} }) youzanDetail: { avatar: string; userNickname: string; userPhone: string; yzOpenId: string }
  @Prop({ default: () => {} }) couponDetail: BaseCouponItem
  // 兑换类型
  @Prop({ default: 1 }) priceType: 1 | 2
  @Prop({ default: '' }) exchangeCount: number
  @Prop({ default: '' }) leaveCount: number

  couponInfo: FormatCouponInfo | null = null
  isExchanging = false

  get defaultAvatar() {
    return 'https://file.xuantong.cn/header2.jpg'
  }

  get EnumPreferentialType() {
    return EnumPreferentialType
  }

  get canUseWithAnotherCoupon(): boolean {
    return !!(this.couponDetail.composeFlag & IS_COMPOSE_COUPON)
  }

  @Emit('useDesc')
  clickUseDescHandler() {
    return EnumCouponTimeRule.PositionRule1
  }

  @Emit('close')
  onCancel() {}

  onConfirmExchange() {
    if (this.isExchanging) return
    this.isExchanging = true
    this.$emit('confirmExchange', () => {
      this.isExchanging = false
    })
  }

  @Watch('visible', { immediate: true })
  changeVisible(value: boolean) {
    if (!value) return
    this.couponInfo = formatCouponInfo(this.couponDetail, EnumCouponTimeRule.PositionRule1)
  }
}
